import { NgModule, ModuleWithProviders, ErrorHandler } from '@angular/core';
import { SpinnerSmallComponent } from "./helper-components/spinner-small.component";
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AuthGuard, AuthService, RoleGuard, MessageBrokerService, PendingChangesGuard } from './core/index';
import { NoContentComponent, UnAuthorizeComponent, ErrorComponent, SpinnerComponent, NotificationComponent, NotificationsService, LinkTextAreaComponent } from './helper-components/index';
import { GlobalErrorHandler } from './core/error-handler';
import 'materialize-css';
import { MaterializeModule } from 'angular2-materialize';
import { ModalPromptComponent } from './helper-components/modal-prompt.component';
import { ModalPromptService } from './helper-components/modal-prompt.service';
import { AutoGrowDirective } from './auto-grow.directive';
import { AutoResizeDirective } from './auto-resize.directive';
import { PaginatorComponent } from '../clearance-item/pagination/paginator.component';
import { CarouselComponent } from '../clearance-item/carousel.component';
import { ModalComponent } from './helper-components/modal/_directives';
import { NavigationTrackerService } from './helper-components/navigation-tracker.service';


@NgModule({
  imports: [
    BrowserModule,
    MaterializeModule,
    FormsModule
  ],
  declarations: [
    UnAuthorizeComponent,
    NoContentComponent,
    ErrorComponent,
    SpinnerComponent,
    SpinnerSmallComponent,
    NotificationComponent,
    ModalPromptComponent,
    AutoGrowDirective,
    AutoResizeDirective,
    LinkTextAreaComponent,
    PaginatorComponent,
    CarouselComponent,
    ModalComponent
    
  ],
  exports: [
    UnAuthorizeComponent,
    NoContentComponent,
    ErrorComponent,
    SpinnerComponent,
    SpinnerSmallComponent,
    NotificationComponent,
    MaterializeModule,
    HttpModule,
    BrowserModule,
    ModalPromptComponent,
    AutoGrowDirective,
    AutoResizeDirective,
    LinkTextAreaComponent,
    PaginatorComponent,
    CarouselComponent,
    ModalComponent
  ]

})
export class SharedModule {

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        AuthGuard, 
        AuthService, 
        RoleGuard, 
        MessageBrokerService, 
        PendingChangesGuard, 
        NotificationsService,
        GlobalErrorHandler,
        ModalPromptService
      ]
    };
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/shared.module.ts